/** @jsxImportSource @emotion/react */
import { memo } from "react";

import {
  mtgGroup,
  mtgBody
} from "assets/css/stylesCss";

import RadioButton from "components/ui/button/RadioButton";

/**
 * MTGログイン後の選択コンポーネント
 * @param {Object} mtgItems お客さま情報を設定したオブジェクト
 * @param {Boolean} mtgSelfInput true :ラジオボタン「myTOKYOGAS情報は使わない」を表示する
 *                               false: ラジオボタン「myTOKYOGAS情報は使わない」を表示しない
 */
const MtgLoginSelect = memo(({ mtgItems, mtgSelfInput }) => {

  const name = mtgItems[0].name;

  return (
    <>
      <div css={mtgGroup}>
        <p css={mtgBody}>お手続きする契約を選択してください。</p>

        {/** MTGログイン生成 */}
        {mtgItems.map((item, index) => (
          <RadioButton
            key={index}
            id={name + "_" + item.gmtSetNo}
            name={name}
            value={index}
          >
            ご使用場所：{item.fullAddress}
            <br />
            ご契約名義：{item.sei + "　" + item.mei}
          </RadioButton>
        ))}

        {/** myTOKYOGAS情報は使わない */}
        {mtgSelfInput
          ? <RadioButton id={name + "_99"} name={name} value="99">myTOKYOGASの情報は使わない</RadioButton>
          : <></>
        }
      </div>
    </>
  );
});

export default MtgLoginSelect;
